import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';

export interface ISidepanelTab {
  labelPath: string;
  value?: string;
  tooltipLabelPath?: string;
  isBeta?: boolean;
}

@Component({
  selector: 'app-sidepanel-tabs',
  templateUrl: './sidepanel-tabs.component.html',
  styleUrls: ['./sidepanel-tabs.component.scss'],
})
export class SidepanelTabsComponent implements OnInit, OnDestroy {
  @Input() public vertical = false;
  @Input() public style: 'underline' | 'pill' = 'underline';
  @Input() public tabs: ISidepanelTab[];
  @Input() public currentTabIndex = 0;
  @Input() public changeTabIndex?: ReplaySubject<number>;
  @Output() public tabOnSelection = new EventEmitter<number>();

  private _changeTabIndexSubscription$?: Subscription;

  ngOnInit(): void {
    this.tabOnSelection.emit(this.currentTabIndex);
    this._changeTabIndexSubscription$ = this.changeTabIndex?.subscribe((index) => {
      this.currentTabIndex = index;
    });
  }

  ngOnDestroy(): void {
    this._changeTabIndexSubscription$?.unsubscribe();
  }

  public onSelect(selectedIndex: number): void {
    this.currentTabIndex = selectedIndex;
    this.tabOnSelection.emit(this.currentTabIndex);
  }
}
